<div style="width: 1100px; height: 900px;" data-cy="ar-payment-details">
  <div class="spinnder-div" *ngIf="isLoading" data-cy="ar-payment-details-loading">
    <div class="spinner-holder" data-cy="ar-payment-details-spinner-holder">
      <mat-spinner data-cy="ar-payment-details-spinner"></mat-spinner>
    </div>
  </div>
  <div *ngIf="!isLoading" class="section"
    style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-payment-details-content">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-details-header">
      <div class="section-header-title" data-cy="ar-payment-details-title">
        Payment Item Details
      </div>
      <div style="flex: 1;" data-cy="ar-payment-details-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;overflow: auto;" data-cy="ar-payment-details-section-content">
      <!-- body of window-->
      <div style="display: flex; flex-direction: row" data-cy="ar-payment-details-info-container">
        <div style="flex: 1; margin-right: 20px;" data-cy="ar-payment-details-left-column">
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-amount-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-amount-label">Amount</div>
            <div style="flex-basis: 100px;" class="info-cell" data-cy="ar-payment-details-amount-value">{{ ledgerItem.Amount === null ? '&nbsp;' :
              ledgerItem.Amount | currency }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-date-container">
            <div style="display: flex; flex-direction: row; flex: 1" class="cell-container" data-cy="ar-payment-details-posted-container">
              <div style="flex-basis: 120px" data-cy="ar-payment-details-posted-label">Posted</div>
              <div style="flex:1" class="info-cell" data-cy="ar-payment-details-posted-value">{{ ledgerItem.PostDate === null ? '&nbsp;' :
                ledgerItem.PostDate | date }}</div>
            </div>
            <div style="display: flex; flex-direction: row; flex: 1" class="cell-container" data-cy="ar-payment-details-received-container">
              <div style="flex-basis: 120px; padding-left: 25px;" data-cy="ar-payment-details-received-label">Received</div>
              <div style="flex:1" class="info-cell" data-cy="ar-payment-details-received-value">{{ payment.PaymentReceivedDate === null ? '&nbsp;' :
                payment.PaymentReceivedDate | date }}</div>
            </div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-user-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-user-label">User</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-user-value">{{ ledgerItem.PostedBy ? ledgerItem.PostedBy : '&nbsp;' }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-from-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-from-label">From</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-from-value">{{ payment?.PayerFirstName ? payment.PayerFirstName + ' ' +
              payment.PayerLastName : (payment?.PayerName ? payment.PayerName : '&nbsp;') }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-type-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-type-label">Type</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-type-value">{{ payment ? payment.PaymentType : '&nbsp;' }} {{ payment?.PaymentType
            ==='Electronic' ? payment.PaymentElectronicType : '&nbsp;' }} {{payment.IsRecurring? '/ Recurring':''}}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-source-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-source-label">Payment Source</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-source-value">{{ payment ? payment.PaymentApplicationSource : '&nbsp;' }}</div>
          </div>
        </div>

        <div style="flex: 1" data-cy="ar-payment-details-right-column">
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-status-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-status-label">Status</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-status-value">{{ payment ? payment.PaymentStatus : '&nbsp;' }}</div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-tdo-number-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-tdo-number-label">TDO Payment #</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-tdo-number-value">{{ payment ? payment.TDOPaymentReferenceNumber : '&nbsp;' }} </div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-reference-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-reference-label">Reference</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-reference-value">{{ ledgerItem.Reference ? ledgerItem.Reference : '&nbsp;' }}</div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-description-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-description-label">Description</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-description-value">{{ ledgerItem.Description ? ledgerItem.Description : '&nbsp;' }}</div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-details-account-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-details-account-label">Account</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-details-account-value">{{ payment?.ARAccountName ? payment.ARAccountName : '&nbsp;' }}</div>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: row" class="cell-container"
        *ngIf="(this.notes && this.notes.length > 0) || payment.RecurringMessage != null" data-cy="ar-payment-details-notes-container">
        <div style="flex-basis: 120px" data-cy="ar-payment-details-notes-label">Note(s)</div>
        <div style="flex:1" data-cy="ar-payment-details-notes-value">
          <div *ngIf="this.notes && this.notes.length > 0" style="flex:1" class="info-cell" data-cy="ar-payment-details-note">{{ this.notes[0].Note }}
          </div>
          <div *ngIf="payment.RecurringMessage != null && payment.RecurringMessage != ''" style="flex:1"
            class="info-cell" data-cy="ar-payment-details-recurring-message">{{ payment.RecurringMessage}}</div>
        </div>
      </div>

      <div style="font-weight: bold" data-cy="ar-payment-details-distributions-header">Payment Distributions</div>

      <div style="border: solid 1px var(--tdo-purple-light); height: 100%; width:100%" data-cy="ar-payment-details-distributions-container">
        <span *ngIf="!this.paymentDistributions.length" data-cy="ar-payment-details-no-distributions">No payment distributions recorded.</span>
        <tdo-table *ngIf="this.paymentDistributions.length>0" [dataSource]="this.paymentDistributions"
                   cypressControlIdentifier="payment-distributions-results" [isMultiSelection]="false" [isUsePaginator]="false"
                   [isSearchable]="false" style="max-height: 250px;" data-cy="ar-payment-details-distributions-table">
          <tdo-table-column [displayName]="ledgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypePatient? 'Pat. Estimate':'Ins. Estimate'" propertyName="Estimate" isSortable="false" [rowTemplate]="estimateAmount" data-cy="ar-payment-details-distributions-col-estimate">
            <ng-template #estimateAmount let-row>
              <div *ngIf="ledgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypePatient" data-cy="ar-payment-details-distributions-patient-estimate">{{ row.model.PatientEstimateAmount | currency }}</div>
              <div *ngIf="ledgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypeInsurance" data-cy="ar-payment-details-distributions-insurance-estimate">{{ row.model.InsuranceEstimateAmount | currency }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Paid" propertyName="Amount" isSortable="false" [rowTemplate]="paymentAmount" data-cy="ar-payment-details-distributions-col-paid">
            <ng-template #paymentAmount let-row>
              <div *ngIf="row.Amount || row.Amount === 0" data-cy="ar-payment-details-distributions-amount">{{ row.Amount | currency }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Date" propertyName="PostDate" isSortable="false" [rowTemplate]="date" data-cy="ar-payment-details-distributions-col-date">
            <ng-template #date let-row>
              <div *ngIf="row.model.PostDate" data-cy="ar-payment-details-distributions-date">{{ row.model.PostDate | date }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Code" propertyName="Code" isSortable="false" [rowTemplate]="code" data-cy="ar-payment-details-distributions-col-code">
            <ng-template #code let-row>
              <div *ngIf="row.model.Code" data-cy="ar-payment-details-distributions-code">{{ row.model.Code }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Description" propertyName="Description" isSortable="false"
                            [rowTemplate]="description" data-cy="ar-payment-details-distributions-col-description">
            <ng-template #description let-row>
              <div *ngIf="row.model.Description" data-cy="ar-payment-details-distributions-description">{{ row.model.Description }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Type" propertyName="Type" isSortable="false" [rowTemplate]="type" data-cy="ar-payment-details-distributions-col-type">
            <ng-template #type let-row>
              <div *ngIf="row.model.Type" data-cy="ar-payment-details-distributions-type">{{ row.model.Type }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Status" propertyName="Status" isSortable="false" [rowTemplate]="status" data-cy="ar-payment-details-distributions-col-status">
            <ng-template #status let-row>
              <div *ngIf="row.model.Status" data-cy="ar-payment-details-distributions-status">{{ row.model.Status }}</div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>


      <div style="font-weight: bold" data-cy="ar-payment-details-credits-header">Credits</div>

      <div style="border: solid 1px var(--tdo-purple-light); height: 100%; width:100%" data-cy="ar-payment-details-credits-container">
        <span *ngIf="!payment.credits.length" data-cy="ar-payment-details-no-credits">No credits recorded.</span>
        <tdo-table *ngIf="payment.credits.length>0" [cypressControlIdentifier]="'payment-credit-item'"
                   [dataSource]="payment.credits" [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false" data-cy="ar-payment-details-credits-table">
          <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true" [rowTemplate]="postDate" data-cy="ar-payment-details-credits-col-date">
            <ng-template #postDate let-row>
              <div matTooltip="{{ convertUTCDatetoTimezone(row.model.PostDate, this.TZID) | date:'medium' }}" data-cy="ar-payment-details-credits-date">
                {{ convertUTCDatetoTimezone(row.model.PostDate, this.TZID) | date }}
              </div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Reference" propertyName="Reference" isSortable="true" [rowTemplate]="ref" data-cy="ar-payment-details-credits-col-reference">
            <ng-template #ref let-row>
              <div *ngIf="row.model.Reference" style="max-width: 300px; white-space: pre-line" data-cy="ar-payment-details-credits-reference">
                {{ row.model.Reference }}
              </div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Description" propertyName="Description" isSortable="true"
                            [rowTemplate]="description" data-cy="ar-payment-details-credits-col-description">
            <ng-template #description let-row>
              <div *ngIf="row.model.Description && row.model.Description" style="max-width: 300px; white-space: pre-line" data-cy="ar-payment-details-credits-description">
                {{ row.model.Description }}
              </div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Amount" propertyName="Amount" [rowTemplate]="amt" data-cy="ar-payment-details-credits-col-amount">
            <ng-template #amt let-row>
              <div *ngIf="row.model.Amount" data-cy="ar-payment-details-credits-amount">
                {{ row.model.Amount | currency }}
              </div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="View Distributions" propertyName="LedgerID" [rowTemplate]="view" data-cy="ar-payment-details-credits-col-view">
            <ng-template #view let-row>
              <button mat-icon-button color="primary" aria-label="Check Claim Failed" (click)="openPaymentDistributionDetailsWindow(row.model)" data-cy="ar-payment-details-credits-view-btn">
                <mat-icon [matTooltip]="'Show distribution list'" data-cy="ar-payment-details-credits-view-icon">visibility</mat-icon>
              </button>
            </ng-template>
          </tdo-table-column>

        </tdo-table>
      </div>



    </div>
    <!--  FOOTER-->
    <div class="section-footer"
      style="flex-basis: 60px; padding-top: 10px; padding-right: 10px;flex-direction:row-reverse" data-cy="ar-payment-details-footer">
      <button data-cy="payment-details-close-btn" (click)="close()" class="tdo-button tdo-close"
        style="margin-right: 10px;">Close</button>
      <button [disabled]="isPrintingReceipt" data-cy="payment-details-print-receipt-btn" *ngIf="showReceipt"
        (click)="openPaymentReceipt()" class="tdo-button tdo-close" style="margin-right: 10px;">Print Receipt</button>
    </div>
  </div>
</div>
